// extracted by mini-css-extract-plugin
export default {"percentOutput":"BudgetStatus_percentOutput__N-bCu","budgetTotalsDiv":"BudgetStatus_budgetTotalsDiv__8OPyh"};